module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search for a medical aid",
      "prepend-icon": "search",
      "clearable": "",
      "hint": "Start typing the name of a medical aid"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [(_vm.filteredQuickPick && _vm.filteredQuickPick.length > 0) ? _c('v-subheader', [_vm._v("Quick pick")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredQuickPick), function(medicalaid, index) {
    return [_c('v-list-tile', {
      key: ("li-" + (medicalaid.email) + "-" + index),
      on: {
        "click": function($event) {
          return _vm.select(medicalaid)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(medicalaid.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(medicalaid.email))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (medicalaid.email) + "-" + index)
    })]
  }), _vm._v(" "), _c('v-subheader', [_vm._v("All medical aids")]), _vm._v(" "), _vm._l((_vm.filteredResults), function(medicalaid, index) {
    return [_c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.select(medicalaid)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(medicalaid.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(medicalaid.email))])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: (index + "-div")
    })]
  }), _vm._v(" "), (_vm.filteredResults.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Your search returned no results.\n          "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.searchString = ""
      }
    }
  }, [_vm._v("Try again?")])], 1)], 1)], 1) : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab319c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/MedicalAidPicker.vue
// module id = 1457
// module chunks = 9